// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================================
                               REPORTS main CSS
===========================================================================*/
.consultant-report-views {
  background: #fbf8f8;
  min-height: 100vh;
}

.consultant-report-views .reports {
  margin-bottom: 20px;
  padding: 0px;
  margin-top: 30px;
}

.consultant-report-views-inputvalues form {
  background: #ffffff;
  border-radius: 2px;
  margin-bottom: 20px;
  padding: 25px;
  margin-top: 0px;
  display: block;
  border: 1px solid #cccccc;
}

.consultant-report-views h1 {
  
  margin: 25px 0px;
  font-size: 25px;
  text-align: left;
}

.consultant-report-views .reports table {
  margin-top: 20px;
}

.consultant-report-views .reports table th {
  text-align: left !important;
  font-size: 16px;
  background: #fbf8f8;
  color: #000000 !important;
  padding: 8px 5px;
  font-weight: 500;
  
}
.reports.supply-table.two table th:nth-child(1) {
  width: 30% !important;
}
.reports.supply-table.two table th:nth-child(2) {
  width: 24% !important;
}
.reports.supply-table.two table th:nth-child(3) {
  width: 14% !important;
}
.reports.supply-table.two table th:nth-child(4) {
  width: 12% !important;
}
.reports.supply-table.two table th:nth-child(5) {
  width: 10% !important;
}
.reports.supply-table.two table th:nth-child(6) {
  width: 10% !important;
}

.reports.appintment-table.two table th:nth-child(1) {
  width: 25% !important;
}
.reports.appintment-table.two table th:nth-child(2) {
  width: 15% !important;
}
.reports.appintment-table.two table th:nth-child(3) {
  width: 12% !important;
}
.reports.appintment-table.two table th:nth-child(4) {
  width: 13% !important;
}
.reports.appintment-table.two table th:nth-child(5) {
  width: 10% !important;
}
.reports.appintment-table.two table th:nth-child(6) {
  width: 10% !important;
}
.reports.appintment-table.two table th:nth-child(7) {
  width: 15% !important;
}

.reports.transferee-table.two table th:nth-child(1) {
  width: 25% !important;
}
.reports.transferee-table.two table th:nth-child(2) {
  width: 15% !important;
}
.reports.transferee-table.two table th:nth-child(3) {
  width: 14% !important;
}
.reports.transferee-table.two table th:nth-child(4) {
  width: 12% !important;
}
.reports.transferee-table.two table th:nth-child(5) {
  width: 12% !important;
}
.reports.transferee-table.two table th:nth-child(6) {
  width: 10% !important;
}
.reports.transferee-table.two table th:nth-child(7) {
  width: 12% !important;
}

.react-datepicker__input-container {
  width: 100%;
}
.react-datepicker-wrapper {
  width: 100%;
}

.consultant-report-views .reports table td {
  text-align: left !important;
  font-size: 15px;
  padding: 10px 5px;
  font-weight: 500;
  
  white-space: normal;
  word-break: break-all;
}
.consultant-report-views .reports table td span {
  text-align: left;
  font-size: 15px;
  padding: 10px 5px;
  font-weight: 500;
  
}

.consultant-report-views-inputvalues form .form-control {
  border: 0;
  border-bottom: 1px solid #ccc;
  border-radius: 0px;
  background: #ffffff;
  box-shadow: none;
}
.consultant-report-views-inputvalues form .form-control.is-invalid {
  border-color: #e2211a;
}
.consultant-report-views-inputvalues form .input-group-addon {
  border: 0;
  border-bottom: 1px solid #ccc;
  border-radius: 0px;
  background: #ffffff;
  box-shadow: none;
}

.consultant-report-views-inputvalues form label {
  margin-bottom: 0px;
  font-weight: 500;
  font-size: 13px;
  
  color: #676767;
  position: relative;
  top: 2px;
}

.consultant-report-views-inputvalues .btn {
  background: #007cfb;
  color: #ffffff;
  
  margin-top: 20px;
  padding: 6px 20px;
}

.consultant-report-views .heaidng-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.consultant-report-views .heaidng-view .btn {
  border: 2px solid #007cfb;
  
  padding: 6px 15px;
  background: transparent;
  color: #007cfb;
  font-weight: 500;
  margin: 0px;
}

.consultant-report-views table thead tr {
  border: 1px solid #fbf8f8;
  border-bottom: 1px solid #cccccc;
}

.consultant-report-views table tbody tr {
  border: 1px solid #cccccc;
  background: #ffffff;
}
.input-group.date .svg-inline--fa.fa-w-14 {
  width: 0.875em;
  position: absolute;
  right: 5px;
  top: 15px;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Supplier/Reports/common/css/reports.css"],"names":[],"mappings":"AAAA;;4EAE4E;AAC5E;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;;AAElB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;;EAEhB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;;AAElB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;;EAEf,cAAc;EACd,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;;EAEd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;;EAEzB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX","sourcesContent":["/* =========================================================================\n                               REPORTS main CSS\n===========================================================================*/\n.consultant-report-views {\n  background: #fbf8f8;\n  min-height: 100vh;\n}\n\n.consultant-report-views .reports {\n  margin-bottom: 20px;\n  padding: 0px;\n  margin-top: 30px;\n}\n\n.consultant-report-views-inputvalues form {\n  background: #ffffff;\n  border-radius: 2px;\n  margin-bottom: 20px;\n  padding: 25px;\n  margin-top: 0px;\n  display: block;\n  border: 1px solid #cccccc;\n}\n\n.consultant-report-views h1 {\n  \n  margin: 25px 0px;\n  font-size: 25px;\n  text-align: left;\n}\n\n.consultant-report-views .reports table {\n  margin-top: 20px;\n}\n\n.consultant-report-views .reports table th {\n  text-align: left !important;\n  font-size: 16px;\n  background: #fbf8f8;\n  color: #000000 !important;\n  padding: 8px 5px;\n  font-weight: 500;\n  \n}\n.reports.supply-table.two table th:nth-child(1) {\n  width: 30% !important;\n}\n.reports.supply-table.two table th:nth-child(2) {\n  width: 24% !important;\n}\n.reports.supply-table.two table th:nth-child(3) {\n  width: 14% !important;\n}\n.reports.supply-table.two table th:nth-child(4) {\n  width: 12% !important;\n}\n.reports.supply-table.two table th:nth-child(5) {\n  width: 10% !important;\n}\n.reports.supply-table.two table th:nth-child(6) {\n  width: 10% !important;\n}\n\n.reports.appintment-table.two table th:nth-child(1) {\n  width: 25% !important;\n}\n.reports.appintment-table.two table th:nth-child(2) {\n  width: 15% !important;\n}\n.reports.appintment-table.two table th:nth-child(3) {\n  width: 12% !important;\n}\n.reports.appintment-table.two table th:nth-child(4) {\n  width: 13% !important;\n}\n.reports.appintment-table.two table th:nth-child(5) {\n  width: 10% !important;\n}\n.reports.appintment-table.two table th:nth-child(6) {\n  width: 10% !important;\n}\n.reports.appintment-table.two table th:nth-child(7) {\n  width: 15% !important;\n}\n\n.reports.transferee-table.two table th:nth-child(1) {\n  width: 25% !important;\n}\n.reports.transferee-table.two table th:nth-child(2) {\n  width: 15% !important;\n}\n.reports.transferee-table.two table th:nth-child(3) {\n  width: 14% !important;\n}\n.reports.transferee-table.two table th:nth-child(4) {\n  width: 12% !important;\n}\n.reports.transferee-table.two table th:nth-child(5) {\n  width: 12% !important;\n}\n.reports.transferee-table.two table th:nth-child(6) {\n  width: 10% !important;\n}\n.reports.transferee-table.two table th:nth-child(7) {\n  width: 12% !important;\n}\n\n.react-datepicker__input-container {\n  width: 100%;\n}\n.react-datepicker-wrapper {\n  width: 100%;\n}\n\n.consultant-report-views .reports table td {\n  text-align: left !important;\n  font-size: 15px;\n  padding: 10px 5px;\n  font-weight: 500;\n  \n  white-space: normal;\n  word-break: break-all;\n}\n.consultant-report-views .reports table td span {\n  text-align: left;\n  font-size: 15px;\n  padding: 10px 5px;\n  font-weight: 500;\n  \n}\n\n.consultant-report-views-inputvalues form .form-control {\n  border: 0;\n  border-bottom: 1px solid #ccc;\n  border-radius: 0px;\n  background: #ffffff;\n  box-shadow: none;\n}\n.consultant-report-views-inputvalues form .form-control.is-invalid {\n  border-color: #e2211a;\n}\n.consultant-report-views-inputvalues form .input-group-addon {\n  border: 0;\n  border-bottom: 1px solid #ccc;\n  border-radius: 0px;\n  background: #ffffff;\n  box-shadow: none;\n}\n\n.consultant-report-views-inputvalues form label {\n  margin-bottom: 0px;\n  font-weight: 500;\n  font-size: 13px;\n  \n  color: #676767;\n  position: relative;\n  top: 2px;\n}\n\n.consultant-report-views-inputvalues .btn {\n  background: #007cfb;\n  color: #ffffff;\n  \n  margin-top: 20px;\n  padding: 6px 20px;\n}\n\n.consultant-report-views .heaidng-view {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.consultant-report-views .heaidng-view .btn {\n  border: 2px solid #007cfb;\n  \n  padding: 6px 15px;\n  background: transparent;\n  color: #007cfb;\n  font-weight: 500;\n  margin: 0px;\n}\n\n.consultant-report-views table thead tr {\n  border: 1px solid #fbf8f8;\n  border-bottom: 1px solid #cccccc;\n}\n\n.consultant-report-views table tbody tr {\n  border: 1px solid #cccccc;\n  background: #ffffff;\n}\n.input-group.date .svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n  position: absolute;\n  right: 5px;\n  top: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
